import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EventStageStatus } from './event-stage-status';
import { EventTemplate } from './event-template';
import { EventTemplateAttributeInput } from './event-template-attribute-input';
import { EventUsers } from './event-users';
import { RelatedItem } from './related-item';
export class Event implements ViewModel {
  friendlyTypeNameSingular: string = 'Event';
  apiRoute: string = CONFIG.apiRoutes.events;

  eventId: string;
  name: string;
  scope: string;
  creationDate: string;
  relatedItems: RelatedItem[];
  eventTemplateId: string;
  eventTemplate: EventTemplate;
  attributeInputs: EventTemplateAttributeInput[] = [];
  eventStageStatus: EventStageStatus[] = [];
  currentProcessStageId: string;
  userId: string;
  username: string;
  eventUsers: EventUsers[] = [];
  identifierName: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.eventId = data.eventId;
    this.name = data.name;
    this.scope = data.scope;
    this.creationDate = data.creationDate;
    this.currentProcessStageId = data.currentProcessStageId;
    this.userId = data.userId;
    this.username = data.username;
    this.identifierName = data.identifierName;

    this.eventTemplateId = data.eventTemplateId;
    if (data.eventTemplate) {
      const eventTemplate = new EventTemplate();
      eventTemplate.loadFromJson(data.eventTemplate);
      this.eventTemplate = eventTemplate;
    }

    this.relatedItems = [];
    if (data.relatedItems && data.relatedItems.length > 0) {
      this.relatedItems = data.relatedItems.map(i => {
        const item = new RelatedItem();
        item.loadFromJson(i);
        return item;
      });
    }

    if (data.attributeInputs) {
      data.attributeInputs.forEach(attrInput => {
        const newAttrInput = new EventTemplateAttributeInput();
        newAttrInput.loadFromJson(attrInput);
        this.attributeInputs.push(newAttrInput);
      });
    }

    if (data.eventStageStatus) {
      data.eventStageStatus.forEach(stageStatus => {
        const newStageStatus = new EventStageStatus();
        newStageStatus.loadFromJson(stageStatus);
        this.eventStageStatus.push(newStageStatus);
      });
    }

    if (data.eventUsers) {
      data.eventUsers.forEach(eventUser => {
        const newEventUsers = new EventUsers();
        newEventUsers.loadFromJson(eventUser);
        this.eventUsers.push(newEventUsers);
      });
    }
  }

  public isStageComplete(processStageId: string): boolean {
    const eventStageStatus = this.eventStageStatus.find(e => e.processStageId === processStageId);
    return (eventStageStatus && eventStageStatus.isComplete) || false;
  }

  public addCompleteStageStatus(processStageId: string): void {
    const existing = this.eventStageStatus.find(e => e.processStageId === processStageId);
    if (!existing) {
      const newEventStageStatus = new EventStageStatus();
      newEventStageStatus.eventId = this.eventId;
      newEventStageStatus.isComplete = true;
      newEventStageStatus.processStageId = processStageId;
      this.eventStageStatus.push(newEventStageStatus);
    }
  }

  public removeCompleteStageStatus(processStageId: string): void {
    const existing = this.eventStageStatus.find(e => e.processStageId === processStageId && e.isComplete);
    if (existing) {
      const index = this.eventStageStatus.indexOf(existing);
      if (index > -1) {
        this.eventStageStatus.splice(index, 1);
      }
    }
  }
}
